import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { moduleActionContext } from '@/store';
const filesModule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default filesModule;
export const filesModuleActionContext = (context) => moduleActionContext(context, filesModule);
